/* eslint-disable react/prop-types */
import { withStyles } from '@material-ui/core';
import React from 'react'; // eslint-disable-line
import { ExpansionPanel } from '../../../../../../forms/form-components/expansion-panel/expansion-panel';
import styles, { StyledComponent } from '../../../../../../styles/styles';
import { GuaranteedPaymentPeriodView } from '../../details/guaranteed-payment-period-claims';
import { FormDetails } from '../../form-details-reducer';
import { OtherBenefitsView } from '../../details/other-benefits';
import { PermanentImpairmentClaimsView } from '../../details/permanent-impairment-claims';
import { OccupationalDisabilityOverHeadView } from '../../details/occupational-disability-over-head';
import { OccupationalDisabilityOverHeadTwoView } from '../../details/occupational-disability-over-head-two';
import { InabilityToPerformOccupationView } from '../../details/inability-perform-occupation-details';

interface BaseProps {
    formDetails?: FormDetails;
    disableEditButton?: boolean;
}

interface Props extends StyledComponent, BaseProps {}

const claimInformationDetailsView: React.FunctionComponent<Props> = ({
    formDetails,
    disableEditButton,
}) => {
    return (
        <ExpansionPanel
            name="Claim Information details"
            style={{ marginLeft: -24, marginRight: -24 }}
        >
            <React.Fragment>
                <GuaranteedPaymentPeriodView formDetails={formDetails} />
                <PermanentImpairmentClaimsView formDetails={formDetails} />
                <OccupationalDisabilityOverHeadView formDetails={formDetails} />
                <OccupationalDisabilityOverHeadTwoView formDetails={formDetails} />
                <InabilityToPerformOccupationView formDetails={formDetails} />
                <OtherBenefitsView formDetails={formDetails} />
            </React.Fragment>
        </ExpansionPanel>
    );
};

export const ClaimInformationDetailsView = withStyles(styles)(claimInformationDetailsView);
